import { FnwNavigationService, FnwRejectNavigation, FnwSectionChange } from '@farmnet/webapp-loader-companion';
import * as angular from 'angular';

angular.module('cfn').service('navigationService', navigationService);

navigationService.$inject = [
  '$rootScope',
  '$location',
  '$window',
  'i18nFilter',
  'fnwNavigationService'
];

declare var _:any;

function navigationService($rootScope, $location, $window, i18nFilter, fnwNavigationService: FnwNavigationService) {
  var urlMatcher = /^\/?([^/?]*)/;

  var VALID_SECTIONS = [
    'admin',
    'calendar',
    'cattle',
    'core',
    'crop',
    'dashboard',
    'developer',
    'farm',
    'farmMap',
    'livestock',
    'myFarmMap',
    'shop'
  ];

  var SECTIONS = {
    ADMIN: 'admin',
    CALENDAR: 'calendar',
    CATTLE: 'cattle',
    CROP: 'crop',
    DASHBOARD: 'dashboard',
    DEVELOPER: 'developer',
    FARM: 'farm',
    FARMMAP: 'farmMap',
    GENERICFARMMAP: 'myFarmMap',
    LIVESTOCK: 'livestock',
    MYFARMMAP: 'myFarmMap',
    SHOP: 'shop',
    TERMS: 'terms'
  };

  var SPECIAL_CASE_SECTION = {};

  var pageLeavingCheck: any = null;
  var navigationCancelled = false;

  $rootScope.$on('$locationChangeSuccess', () => {
    fnwNavigationService.angularJsNavigationEnd();
  });

  $rootScope.$on('$locationChangeStart', function(event, next, current) {
    fnwNavigationService.angularJsNavigationStart();
    if (pageLeavingCheck != null && pageLeavingCheck.isUnsavedFn() && stripTrailingSlash(next) !== stripTrailingSlash(current)) {
      var allow = $window.confirm(pageLeavingCheck.message);
      if (!allow) {
        event.preventDefault();
        fnwNavigationService.abortAngularJsNavigation();

        // Webapp-loader should cancel navigation
        if (!navigationCancelled) {
          navigationCancelled = true;
          let currentUrl = /.*#(.*)/.exec(current);
          let wantedUrl = /.*#(.*)/.exec(next);

          const message: FnwRejectNavigation = {
            type: 'fnw-reject-navigation',
            url: currentUrl ? currentUrl[1] : '',
            serviceName: ''
          };

          parent.postMessage(message, location.origin);
        }

        //remove jump if matches.
        if (
          $rootScope.goBackState &&
          $rootScope.goBackState.jumpToLocation === $location.url()
        ) {
          abortJump();
        }
      } else {
        //go through, remove check
        navigationCancelled = false;
        pageLeavingCheck = null;
      }
    }
  });

  function stripTrailingSlash(text: string) {
    if (text.endsWith('/')) {
      return text.substring(0, text.length - 1);
    }
    return text;
  }

  function isNavigationCancelled() { return navigationCancelled; }
  function resetNavigationCancelled() { navigationCancelled = false; }

  function getCoreRoute(coreObjectType, id) {
    const exceptions = {
      machine: id =>
        id
          ? `coredata-service/machines/detail/${id}`
          : 'coredata-service/machines',
      person: id =>
        id
          ? `coredata-service/persons/detail/${id}`
          : 'coredata-service/persons',
      farm: id =>
        id
          ? `coredata-service/farms/detail/${id}`
          : 'coredata-service/farms',
      crop: id =>
            'crop'
    };

    if (coreObjectType in exceptions) {
      return exceptions[coreObjectType](id);
    }

    return (
      'core/' + (coreObjectType ? coreObjectType + '/' + (id || '') : 'index')
    );
  }

  return {
    /** Well-known section mappings */
    SECTIONS: SECTIONS,

    /** Existing sections */
    VALID_SECTIONS: VALID_SECTIONS,

    getCoreRoute: getCoreRoute,
    /**
     * Sets a section mapping for the first level of a route.
     */
    registerRouteUrlForSection: registerRouteUrlForSection,

    /**
     * Sets a special case section mapping for a complete route.
     */
    registerRouteUrlForSpecialCaseSection: registerRouteUrlForSpecialCaseSection,

    /** Sets the current section to the given well-known one */
    setSection: setSection,

    /** Sets the current section from a given url (default: dashboard) */
    setSectionFromRouteUrl: setSectionFromRouteUrl,

    /** register a function that tells if there are unsaved changes which will
     * trigger a popup avoiding the user to leave the page unknowingly.
     * If a jump was registered it will be removed in case the user decides
     * not to leave the page.
     * @param {Function} isUnsavedFn -  a function that returns truthy if there are unsaved changes
     * @param {Object} config - the config Object
     * @param {String} config.message - (optional) the message to display in the popup
     */
    registerUnsavedChangesCheck: registerUnsavedChangesCheck,

    /** Changes the route as required but get show a banner to get back to the current one
     * @param {string} route to jump to
     * @param {Object} config - configuration object
     * @param {String} config.title - (optional) the text to be displayed in the return banner
     * @param {String} config.type - (optional) no idea
     * @param {Object} config.jumpPayload - (optional) payload to pass to the jump target
     * @param {Object} config.returnPayload - (optional) payload to give back after returning
     * */
    jumpWithGoBack: jumpWithGoBack,

    /** signals that an already triggered jump should be aborted.
     * (e.g. if the user is confronted with the information he will lose data, and decide otherwise)
     */
    abortJump: abortJump,

    /** called from routes expected to get called and react to such jumps
     * (e.g. to activate a specific tab as required in the jumpPayload)
     * @returns {Object} resolve - object that signals this is the target of a jump (null otherwise)
     * @returns {Object} resolve.data - (optional) jumpPayload
     */
    resolveJump: resolveJump,

    /** called from a route to react to the fact that it's getting back from a jump
     * (e.g. to retain previous values as stored in the returnPayload)
     * @returns {Object} resolve - object that signals this is the target of a go back (null otherwise)
     * @returns {Object} resolve.data - (optional) returnPayload
     * */
    resolveGoBack: resolveGoBack,

    isNavigationCancelled: isNavigationCancelled,
    resetNavigationCancelled: resetNavigationCancelled
  };

  function registerUnsavedChangesCheck(isUnsavedFn, config: any = {}) {
    if (_.isFunction(isUnsavedFn)) {
      const url = $location.url();
      pageLeavingCheck = {
        from: url,
        isUnsavedFn: isUnsavedFn,
        message:
          config.message ||
          i18nFilter(
            'fe.message.confirm.unsavedModifications',
            'Unsaved changes will be lost when leaving this page. Do you want to continue anyway?'
          )
      };
    }
  }

  function setSection(section) {
    $rootScope.sectionName = section;
  }

  function setSectionFromRouteUrl(url) {
    var section = searchUrlInSections(url);

    if (section === undefined) {
      console.info(
        'navigating to unknown section, reset with navigationService.setSection'
      );
      return;
    }

    setSection(section);
  }

  function jumpWithGoBack(jumpToLocation, config) {
    if (jumpToLocation) {
      var config = config || {},
        returnPayload = config.returnPayload,
        jumpPayload = config.jumpPayload,
        type = config.type,
        title = config.title || i18nFilter('fe.common.prev');
      const calledFrom = $location.url();

      const before = $rootScope.goBackState;

      //to make it backwards compatible.
      const state = {
        title,
        type,
        data: returnPayload,
        jumpPayload,
        backlink: calledFrom,
        jumpToLocation,
        before
      };
      $rootScope.goBackState = state;

      $rootScope.goto(jumpToLocation);
    } else {
      console.error('Cannot add jump without a target path.');
    }
  }

  function abortJump() {
    if ($rootScope.goBackState) {
      $rootScope.goBackState = $rootScope.goBackState.before;
    }
  }

  function resolveJump() {
    if ($rootScope.goBackState) {
      const calledIn = $location.url();
      if ($rootScope.goBackState.jumpToLocation === calledIn) {
        return { data: $rootScope.goBackState.jumpPayload }; //done, step consumed
      }
    }
    return null;
  }

  function resolveGoBack() {
    if ($rootScope.goBackState) {
      const calledFrom = $location.url();
      if ($rootScope.goBackState.backlink === calledFrom) {
        const data = $rootScope.goBackState.data;
        $rootScope.goBackState = $rootScope.goBackState.before;
        return { data }; //done, step consumed
      }
    }
    return null;
  }

  function searchUrlInSections(url) {
    if (SPECIAL_CASE_SECTION[url]) {
      return SPECIAL_CASE_SECTION[url];
    }

    const urlMatch = urlMatcher.exec(url);
    let section;

    if (urlMatch && urlMatch.length === 2) {
      const urlSectionPart = urlMatch[1].toUpperCase();
      section = SECTIONS[urlSectionPart];
    }

    return section;
  }

  function registerRouteUrlForSection(route, section) {
    if (VALID_SECTIONS.includes(section)) {
      const urlMatch = urlMatcher.exec(route);
      if (urlMatch && urlMatch.length === 2) {
        const urlSectionPart = urlMatch[1].toUpperCase();
        SECTIONS[urlSectionPart] = section;
      }
    } else {
      console.error('Unknown section', section, route);
    }
  }

  function registerRouteUrlForSpecialCaseSection(route, section) {
    if (VALID_SECTIONS.includes(section)) {
      SPECIAL_CASE_SECTION[route] = section;
    } else {
      console.error('Unknown section', section, route);
    }
  }
}

export default navigationService;
